import { IconType } from "@src/config/icons"
import { clsx } from "clsx"

import { sizeClasses } from "./utils"

export type IconProps = {
  icon: IconType
  size?: keyof typeof sizeClasses
  className?: string
  label?: string
}

export const Icon = ({
  icon,
  size = "default",
  className,
  label,
}: IconProps) => {
  const accessibilityProps = label
    ? { role: "img", "aria-label": label }
    : { "aria-hidden": true }

  return (
    <span
      className={clsx([
        "material-symbols-outlined notranslate",
        "inline-flex items-center leading-none",
        sizeClasses[size],
        className,
      ])}
      translate="no"
      {...accessibilityProps}
    >
      {icon}
    </span>
  )
}
